package editor

import kotlinx.browser.document
import kotlinx.html.*
import kotlinx.html.js.onChangeFunction
import kotlinx.serialization.encodeToString
import org.w3c.dom.HTMLElement
import org.w3c.dom.HTMLInputElement
import org.w3c.files.FileReader
import org.w3c.files.get
import util.DownloadHelper
import util.json

object ImportExportManager {
    fun setup(
        parent: TagConsumer<HTMLElement>,
    ) {
        // drag-and-drop file import
        document.body?.let { dropArea ->
            dropArea.ondragover = {
                it.preventDefault()
            }
            dropArea.ondrop = {
                it.preventDefault()
                val file = it.dataTransfer?.files?.get(0)
                if (file != null) {
                    val reader = FileReader()
                    reader.onload = {
                        val data = reader.result as String
                        EditorManager.setStructure(json.decodeFromString(data))
                    }
                    reader.readAsText(file)
                }
            }
        }

        parent.input {
            id = "import-helper-button"
            style = "display: none"
            type = InputType.file
            onChangeFunction = {
                val input = it.target as HTMLInputElement
                input.files?.get(0)?.let { file ->
                    val reader = FileReader()
                    reader.onload = {
                        val data = reader.result as String
                        EditorManager.setStructure(json.decodeFromString(data))
                    }
                    reader.readAsText(file)
                }
            }
        }
    }

    fun import() {
        (document.getElementById("import-helper-button") as? HTMLInputElement)?.click()
    }

    /**
     * Trigger a download of the current structure as a json file.
     */
    // todo somehow round the numbers to a certain precision?
    //      -> avoid "5.000000000000001" strings etc.
    fun export() {
        val data = json.encodeToString(EditorManager.getStructure())
        DownloadHelper.triggerDownload(data.encodeToByteArray(), "structure.timberix.json", "application/json")
    }
}